export default __webpack_public_path__ + "static/transport-9aad1dfe2789e8fa8c8417c20219f0b3.png";